// extracted by css-extract-rspack-plugin
export default {"root":"root-gst_PF","text":"text-MJGTlK text-sm","title":"title-PgPWUP","subtitle":"subtitle-IfeuTP","action":"action-Yfsm48","centered":"centered-CAK8sr","error":"error-Y8W3_4"};